import React from 'react';
import skype from './skype.png';

function Skype() {
  return <img src={skype} height={25} width={25} />;
}

export default Skype;
